/**
 * Public S3 base URL for DealSauce shared static assets (documents, thumbnails, etc.).
 */
export function getDealsaucePublicBaseUrl() {
  const bucket =
    import.meta.env.VITE_DEALSAUCE_AWS_BUCKET || 'dealsauce-platform'
  return `https://${bucket}.s3.amazonaws.com`
}

export function dealsauceS3Url(key) {
  const normalized = String(key || '').replace(/^\//, '')
  return `${getDealsaucePublicBaseUrl()}/${normalized}`
}
